export default {
  services: `profile/services`,
  update: `profile/services/update`,
  remove: `profile/services/remove`,
};
